export const validateErrorMsg = (error: any) => {
    const errorMsg = error ? error : "Something went wrong"
    return errorMsg
}